import {
    SmallTextHelper, NumberHelper, BooleanHelper
 } from '../PrismicHelpers';
 
 
 export const eventsListHelper = (response ) => {
    const eventsData = response.result;
    let eventsObject = eventsData.map(event => {
        return {
            uid: SmallTextHelper(event.id),
            date: SmallTextHelper(event.data.date),
            image: SmallTextHelper(event.data.image && event.data.image.url),
            description: SmallTextHelper(event.data.description[0] && event.data.description[0].text),
            title: SmallTextHelper(event.data.title[0] && event.data.title[0].text),
            location: SmallTextHelper(event.data.city[0] && event.data.city[0].text),
            url: SmallTextHelper(event.data.url_eventbrite && event.data.url_eventbrite.url),
            live: BooleanHelper(event.data.in_touch_live)
        }
    })
 
    return {
        eventsList: eventsObject
    }
 }
 
 
 export const DocumentListHelper = (response ) => {
    const documentData = response.result;
    let documentsObject = documentData.map(document => {
        return {
            uid: SmallTextHelper(document.id),
            title: SmallTextHelper(document.data.title[0].text),
            url: SmallTextHelper(document.data.document_url.url)
        }
    })
    return {
        documentList: documentsObject
    }
 }

 export const BlogsListHelper = (response ) => {
    const blogsData = response.result;
    let blogsObject = blogsData.map(blog => {
        return {
            id: SmallTextHelper(blog.id),
            uid: SmallTextHelper(blog.uid),
            title: SmallTextHelper(blog.data.blog_title),
            category: SmallTextHelper(blog.data.blog_category),
            slug: SmallTextHelper(blog.uid),
            image: SmallTextHelper(blog.data.blog_image.url),
            description: SmallTextHelper(blog.data.blog_content[0].text),
        }
    })
 
    return {
        blogsList: blogsObject
    }
 }


export const CoursesListHelper = (response) => {
    const courseData = response.result;
    let courseObject = courseData.map(course => {
        return {
            uid: SmallTextHelper(course.id),
            image: SmallTextHelper(course.data.course_image.url),
            title: SmallTextHelper(course.data.course_name),
            description: SmallTextHelper(course.data.course_description),
            url: SmallTextHelper(course.data.trailer_url)
        }
    })
    return {coursesList: courseObject} ;
}

export const PodcastsListHelper = (response) => {
    const podcastData = response.result;
    let podcastObject = podcastData.map(podcast => {
        return {
            uid: SmallTextHelper(podcast.id),
            img: SmallTextHelper(podcast.data.podcast_image.url),
            name: SmallTextHelper(podcast.data.episode_number[0].text),
            desc: SmallTextHelper(podcast.data.podcast_name),
            longDesc: SmallTextHelper(podcast.data.podcast_description),
            seriesName: SmallTextHelper(podcast.data.podcast_series_name),
            playlistName: SmallTextHelper(podcast.data.podcast_series_name),
            src: SmallTextHelper(podcast.data.podcast_media.url),
            webUrl: SmallTextHelper(podcast.data.podcast_url),
            type: 'episode'
        }
    })
    return {podcastsList: podcastObject} ;
}

export const PodcastsSeriesListHelper = (response) => {
    const seriesData = response.result;
    let seriesObject = seriesData.map(series => {
        return {
            uid: SmallTextHelper(series.id),
            image: SmallTextHelper(series.data.series_image.url),
            title: SmallTextHelper(series.data.series_title),
            description: SmallTextHelper(series.data.series_description),
            episodes: series.data.podcast_list,
            type: 'series'
        }
    })
    return {seriesList: seriesObject} ;
}

export const WebinarsListHelper = (response) => {

    const webinarData = response.result;
    let webinarObject = webinarData.map(webinar => {
        return {
            uid: SmallTextHelper(webinar.uid),
            id: SmallTextHelper(webinar.id),
            image: SmallTextHelper(webinar.data.webinar_image.url),
            title: SmallTextHelper(webinar.data.webinar_name),
            description: SmallTextHelper(webinar.data.webinar_description),
            copy: webinar.data.webinar_copy,
            url: SmallTextHelper(webinar.data.webinar_url),
            price: SmallTextHelper(webinar.data.webinar_price),
            currency: SmallTextHelper(webinar.data.price_currency),
            media: SmallTextHelper(webinar.data.media_type),
            document: SmallTextHelper(webinar.data.document_download_link),
            product_id: NumberHelper(webinar.data.product_id)
        }
    })
    return {webinarsList: webinarObject} ;
}

export const BannerListHelper = (response) => {
    const bannerData = response.result;
    let bannerObject = bannerData[0].data.banner_list.map(banner => {
        return {
            heading: SmallTextHelper(banner.heading),
            bodyCopy: SmallTextHelper(banner.body),
            ctaCopy: SmallTextHelper(banner.cta_copy),
            ctaLink: SmallTextHelper(banner.cta_link),
            image: SmallTextHelper(banner.image.url)
        }

    })
    return {bannersList: bannerObject} ;
}


// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-custom-helpers/HomepageCardHelpers.js